module.exports = __webpack_public_path__ + "img/isa4.440a303a.png";